<button
  *ngIf="companyName != 'homehunt' || (companyName == 'homehunt' && userType != 'agent')"
  id="savepop_btn"
  [matMenuTriggerFor]="viewAgentDropDown"
  tabindex="8"
  name="view saved searches"
  aria-label="view saved searches"
  class="saved_search dropdown-toggle"
  (click)="openViewSearch()"
>
  Saved Searches
</button>

<mat-menu class="search-popup" #viewAgentDropDown="matMenu">
  <div class="side_submenu" (click)="$event.stopPropagation()">
    <div (keydown.tab)="$event.stopPropagation()">
      <div class="fldlist">
        <div class="row mt-3">
          <div class="col-md-10 col-sm-10 col-10 f-label">
            <h5 class="pl-3">Saved Searches</h5>
          </div>
          <div class="col-md-2 col-sm-2 col-2 field">
            <button class="submenu_close" (click)="close()"></button>
          </div>
        </div>
        <!-- <div class="mb-2">
          <mat-icon class="close-menu" (click)="close()">clear</mat-icon>
        </div> -->
        <div class="clearfix"></div>
        <ul
          *ngIf="
            savedSearchesAndFilters | viewSearch: { searchInput: searchInput, searchType: searchType } as savedSearches
          "
        >
          <div *ngIf="savedSearches && savedSearches.length > 0">
            <ng-container *ngFor="let property of savedSearches; let i = index">
              <li>
                <div
                  class="pull-left save-search-item"
                  style="width: 100%"
                  (click)="rePopulateSavedData(property)"
                  tabindex="3"
                  (keydown.enter)="rePopulateSavedData(property)"
                >
                  <p class="headname d-flex truncate" area-label="Saved Search">
                    <i class="material-icons">save</i> <span class="pl-2">{{ property.name }}</span>
                  </p>
                  <!-- <p class="hourWrap">{{ property.fromNow }}</p> -->
                </div>
              </li>
            </ng-container>
          </div>
          <div class="alert alert-warning mt-3 btn-block" *ngIf="savedSearches && savedSearches.length === 0">
            No result found
          </div>
          <div class="clearfix buttonWrap mb-3 mt-2">
            <a
              class="btn_100 mt-1 line_btn btn-link"
              routerLink="/savedSearches"
              *ngIf="savedSearches && savedSearches.length > 0"
              tabindex="3"
              aria-label="go to saved searches page"
            >
              <span> All saved search</span>
            </a>
          </div>
        </ul>
      </div>
    </div>
  </div>
</mat-menu>

<!-- <button class="saved_search" name="view saved searches" aria-label="view saved searches">Sell</button>

<button class="saved_search" name="view saved searches" aria-label="view saved searches">Invest</button> -->
